import React, { Component } from 'react';
import PropTypes from 'prop-types';

const MENU_TIMEOUT = 300;

class HoverMenu extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    menu: PropTypes.node,
  };
  static defaultProps = {
    menu: 'Here comes menu',
  };

  constructor(props) {
    super(props);
    this.state = {
      timeout: null,
      show: false,
    };
  }

  showMenu = () => {
    this.setState({ show: true, timeout: null });
  };

  hideMenu = () => {
    const timeout = setTimeout(() => {
      this.setState({ show: false });
    }, MENU_TIMEOUT);

    this.setState({ timeout });
  };

  render() {
    return (
      <div
        className="c-hovermenu"
        ref={(el) => {
          this.el = el;
        }}
        onMouseOver={this.showMenu}
        onMouseLeave={this.hideMenu}
      >
        {this.props.children}
        <div className="c-hovermenu__menu" display-if={this.state.show}>
          {this.props.menu}
        </div>
      </div>
    );
  }
}

export default HoverMenu;
